import { FormattedMessage } from 'react-intl'
import React from 'react'
import { OrderStatusType } from '@src/types/graphql-types'
import messages, { Message } from '@src/routes/OrderCenter/messages'

export const getOrderStatusMessage = (statusAlias: string): Message => {
  return messages[statusAlias] || messages.UNKNOWN
}

export const renderOrderStatusText = (statusAlias: string): JSX.Element => {
  return <FormattedMessage {...getOrderStatusMessage(statusAlias)} />
}

export function renderQuoteStatusText(status: string) {
  switch (status) {
    case OrderStatusType.Empty:
      return <FormattedMessage {...messages.NOT_AVAILABLE} />
    case OrderStatusType.Open:
      return <FormattedMessage id="OPEN" defaultMessage="Open" />
    case OrderStatusType.InProgress:
      return <FormattedMessage {...messages.PARTIALLY_COMPLETED} />
    case OrderStatusType.Complete:
      return <FormattedMessage {...messages.COMPLETE} />
    case OrderStatusType.Pending:
      return <FormattedMessage {...messages.WIMS_QUOTE_STATUS_G} />
    case OrderStatusType.Rejected:
      return <FormattedMessage {...messages.WIMS_ORDER_STATUS_R} />
    case OrderStatusType.Expired:
      return <FormattedMessage {...messages.EXPIRED} />
    default:
      return ''
  }
}
